import sgFreespinTransitionComponent from "components/sg-freespin-transition-component";
import {RequireStageLoadCommand} from "slotworks/commands/loading/require-stage-load-command";
import Components from "slotworks/components/components";
import PromptContent from "slotworks/components/prompt/prompt-content";
import Layers from "slotworks/graphics/layers/layers";
import AutoplayModel from "slotworks/model/autoplay/autoplay-model";
import gameState from "slotworks/model/game-state";
import {Services} from "slotworks/services/services";
import SmartUIFlags, {SmartUIFlag} from "slotworks/smart-ui/smart-ui-flags";
import EnterFreespins from "slotworks/state-machine/standard/states/enter-freespins";
import Contract from "slotworks/utils/contracts/contract";
import Parallel from "slotworks/utils/contracts/parallel";
import Sequence from "slotworks/utils/contracts/sequence";
import backgroundTint from "components/show-win-lines/background-tint";
import sgBackgroundParticles from "components/background/sg-background-particles";
import sgSandAnimation from "components/sg-sand-animation";

export class SGEnterFreespins extends EnterFreespins {

    public onEnter(): void {
        if (AutoplayModel.stopOnFeatureWin) {
            Services.autoplay.stop();
        }
        backgroundTint.hide();
        Components.celebrateWin.cleanup();
        Components.celebrateWin.hide();

        this.startTransition().then(() => this.complete());
    }

    public startTransition(): Contract<void> {
        return new Sequence([
            () => new Parallel([
                () => this.setUIVisible(false),
                () => sgFreespinTransitionComponent.transitionIn()
            ]),
            () => this.setUIVisible(true),
            () => sgFreespinTransitionComponent.resetReels(),
            () => sgSandAnimation.playSandAnimation(),
            () => this.showPrompt()
        ]);
    }

    public showPrompt(): Contract<void> {
        SmartUIFlags.set(SmartUIFlag.PROMPT, true);
        SmartUIFlags.set(SmartUIFlag.FREE_SPINS, true);

        Layers.Background.setScene("freespinsprompt").execute();

        const prompt = new PromptContent(["freespinswin"], Infinity);
        const record = gameState.getCurrentGame().getCurrentRecord();
        prompt.setClickToSkip(true);
        prompt.setText("winMessage", Services.translations.get("fs.tri"));
        //prompt.setText("winMessage", Services.translations.get("fs.tri", {VALUE: record.getFreespinsWon());
        Services.sound.customEvent("fs-intro");
        return new Contract((resolve) => {
            Components.prompt.showPrompt(prompt).then(() => {
                resolve();
            });
        });
    }

    protected setUIVisible(visible: boolean): Contract<void> {
        return Contract.wrap(() => {
            if (visible) {
                Layers.SmartButton.show();
            } else {
                Layers.SmartButton.hide();
            }
        });
    }
}
